var _defs, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgScrollToTop = function SvgScrollToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".scroll-to-top_svg__stt-2{fill:#fff}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#ec6c68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "scroll-to-top_svg__stt-2",
    d: "M22.5 37.64H20V37h5.7v.64h-2.46V44h-.74zM28.3 43.59a3.36 3.36 0 01-1.3-1.27 3.76 3.76 0 010-3.64 3.43 3.43 0 011.32-1.27 4.05 4.05 0 013.77 0 3.43 3.43 0 011.31 1.28 3.51 3.51 0 01.48 1.82 3.57 3.57 0 01-.48 1.83 3.47 3.47 0 01-1.31 1.27 4.05 4.05 0 01-3.77 0zm3.39-.59a2.69 2.69 0 001.05-1 3.11 3.11 0 000-3 2.69 2.69 0 00-1.05-1 3 3 0 00-1.5-.37 3.07 3.07 0 00-1.51.37 2.79 2.79 0 00-1.06 1 3.11 3.11 0 000 3 2.79 2.79 0 001.06 1 3.07 3.07 0 001.51.37 3 3 0 001.5-.37zM40.59 37.64a2.42 2.42 0 010 3.52 3.21 3.21 0 01-2.1.63h-1.88V44h-.74v-7h2.62a3.16 3.16 0 012.1.64zm-.53 3a1.55 1.55 0 00.55-1.28 1.6 1.6 0 00-.55-1.31 2.47 2.47 0 00-1.59-.45h-1.86v3.5h1.86a2.41 2.41 0 001.59-.42zM37.52 31L40 28.41 31 19l-9 9.41L24.48 31 31 24.17 37.52 31z"
  })));
};

export default SvgScrollToTop;